import React, { useState, useEffect } from "react";
import Container from "../../Container/Container";
import Steppers from "../../components/Stepper/Stepper";
import "./Describecampaign.scss";
import Inputfield from "../../components/Textfield/Textfield";
import Textarea from "../../components/Textfield/Textarea";
import Backdrop from "../../components/Backdrop/Backdrop";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { productData } from "../../store/action";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  convertFromHTML,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useTranslation } from "react-i18next";
import Snackbar from "../../components/Snackbar/Snackbar";
import { API, graphqlOperation } from "aws-amplify";
import {
  createProductTable,
  updateProductTable,
} from "../../graphql/mutations";
import { draftId } from "../../store/action/index";
import _ from "lodash";

const Describecampaign = () => {
  const login = useSelector((state) => state.login);
  const product = useSelector((state) => state.product);
  const [brief, setbrief] = useState(product.brief);
  const [shirtname, setShirtname] = useState(product.shirtname);
  const draftProductId = useSelector((state) => state.draftId.draftProductId);
  const [preview, setpreview] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const status = login.loginStatus;
  const [backdrop, setbackdrop] = useState(false);
  const { t } = useTranslation();
  const [msg, setmsg] = useState("");
  const [errMsg, seterrMsg] = useState("");
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (product?.frontImg) {
      history.push("/");
    }
  }, []);
  useEffect(() => {
    dispatch(
      productData({
        step: 3,
      })
    );
  }, []);
  useEffect(() => {
    if (shirtname) {
      var debounce_fun = _.debounce(function () {}, 300);
      debounce_fun();
    }
  }, [shirtname]);

  const save = () => {
    if (shirtname) {
      setLoader(true);
      dispatch(
        productData({
          brief: brief ? brief : product.brief,
          detail: JSON.stringify(
            draftToHtml(
              convertToRaw(
                product?.detail
                  ? editorState2?.getCurrentContent()
                  : editorState?.getCurrentContent()
              )
            )
          ),
          shirtname: shirtname ? shirtname : product?.shirtname,
        })
      );
      setpreview(true);
    } else {
      seterrMsg(t("required-fields"));
      setTimeout(() => {
        seterrMsg("");
      }, 2000);
    }
  };

  useEffect(() => {
    if (preview) {
      addProductStep3();
    }
  }, [preview]);
  const priceroute = () => {
    history.push("/setprice");
  };

  function uploadCallback(file) {
    return new Promise((resolve, reject) => {
      if (file) {
        let reader = new FileReader();
        reader.onload = (e) => {
          resolve({ data: { link: e.target.result } });
        };
        reader.readAsDataURL(file);
      }
    });
  }

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const [editorState2, setEditorState2] = useState(
    () =>
      product.detail &&
      EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(JSON.parse(product.detail))
        )
      )
  );

  const addProductStep3 = async () => {
    setLoader(true);

    const shirt = await {
      brief: product.brief,
      shirtName: product.shirtname,
      detail: product.detail,
      step: 4,
      isDone: false,
    };
    try {
      const { data } = await API.graphql(
        graphqlOperation(updateProductTable, {
          input: { ...shirt, id: draftProductId },
        })
      );
      dispatch(
        draftId({
          draftProductId: data?.updateProductTable
            ? data?.updateProductTable?.id
            : data?.createProductTable?.id,
        })
      );
      history.push("/preview");
      setLoader(false);
    } catch (err) {
      return err;
    }
  };

  const addShirtName = (e) => {
    // const shirt = e.target.value
    // 	.normalize("NFD")
    // 	.replace(/[\u0300-\u036f]/g, "");
    const result = e.target.value.replace(
      /[@&\/\\#,+()^!$~%.'"_=|/:;*?<>{}]/g,
      ""
    );
    setShirtname(result);
  };

  return (
    <>
      <Container>
        <Steppers
          head={t("describe_your_campaign")}
          text={`${t("register")} >`}
          login={status}
          continue={() => save()}
          back={() => priceroute()}
          loader={loader}
        />
        <div className="campaign">
          <div>
            <div className="shirt">
              <img
                src={product.designnimg}
                alt="shirt"
                width={500}
                height={500}
              />
            </div>
          </div>
          <div className="description">
            <Inputfield
              type="text"
              placeholder={t("clothing_name")}
              onChange={(e) => addShirtName(e)}
              value={shirtname}
            />
            <p>{product.sellingPrice} €</p>
            <Textarea
              rows="10"
              cols="110"
              placeholder={t("brief")}
              setbrief={setbrief}
              value={brief}
              style={{ width: "101%" }}
            />
          </div>
          <div></div>
        </div>
        {/* <div className="berief-desc">
					<h2>{t("additional_inform")}</h2>
					<div className="editor">
						<Editor
							defaultEditorState={product.detail ? editorState2 : editorState}
							onEditorStateChange={
								product.detail ? setEditorState2 : setEditorState
							}
							toolbarClassName="toolbarClassName"
							wrapperClassName="wrapperClassName"
							editorClassName="editorClassName"
							toolbar={{
								list: { inDropdown: true },
								textAlign: { inDropdown: true },
								link: { inDropdown: true },
								history: { inDropdown: true },
								image: {
									uploadEnabled: true,
									uploadCallback: uploadCallback,
									previewImage: true,
									inputAccept:
										"image/gif,image/jpeg,image/jpg,image/png,image/svg",
									alt: { present: false, mandatory: false },
									defaultSize: {
										height: 200,
										width: 200,
									},
								},
							}}
						/>
					</div>
				</div> */}
        {backdrop ? (
          <Backdrop setbackdrop={setbackdrop} backdrop={backdrop} />
        ) : null}
        {msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
      </Container>
    </>
  );
};
export default Describecampaign;
